<!-- Page Sidebar Start-->
<div class="logo-wrapper">
  <a routerLink="/" class="brand">
    <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="Go Perform" />
    <img class="img-fluid for-dark"  src="assets/images/logo/logo_dark.png" alt="Go Perform" />
  </a>

  <div class="controls">
    <button class="btn-icon" (click)="sidebarToggle()" aria-label="Collapse sidebar" title="Collapse">
      <i class="fa fa-angle-left"></i>
    </button>

    <button class="btn-icon" (click)="sidebarToggle()" aria-label="Toggle sidebar" title="Toggle">
      <i data-feather="grid" class="status_toggle middle sidebar-toggle"></i>
    </button>

    <!-- Tour Restart Button -->
    <button class="btn-icon tour-btn" (click)="restartTour()" title="Start Tour Again" aria-label="Start tour again">
      <i class="fa fa-question-circle"></i>
    </button>
  </div>
</div>

<div class="logo-icon-wrapper">
  <a href="javascript:void(0)" class="brand-mini" aria-label="Home">
    <img class="img-fluid" src="assets/images/logo/logo-icon.png" alt="Go Perform logo mini" />
  </a>
</div>

<nav class="sidebar-main" role="navigation" aria-label="Primary">
  <div class="left-arrow" id="left-arrow" [class.d-none]="leftArrowNone" (click)="scrollToLeft()">
    <app-feather-icons [icon]="'arrow-left'"></app-feather-icons>
  </div>

  <div
    id="sidebar-menu"
    [ngStyle]="{
      marginLeft:
        this.layout.config.settings.layout == 'Rome' ||
        'Singapore' ||
        'Barcelona'
          ? margin + 'px'
          : '0px'
    }"
  >
    <ul class="sidebar-links custom-scrollbar">
      <!-- ===== Grouped Sections (with full nested children) ===== -->
      <ng-container *ngFor="let section of groupedMenus">
        <!-- Section items -->
        <ng-container *ngFor="let menuItem of section.items">
          <ng-container *ngIf="menuItem.hasPermission">
            <li id="tour-{{ menuItem.id }}" [ngClass]="{ active: menuItem.active }">
              <!-- SUB (Top level) -->
              <ng-container *ngIf="menuItem.type === 'sub'">
                <a
                  href="javascript:void(0)"
                  class="sidebar-link sidebar-title"
                  [class.link-nav]="!menuItem.children"
                  [ngClass]="{ active: menuItem.active }"
                  (click)="toggleMenuAndTour(menuItem)"
                >
                  <i class="side-icon {{ menuItem.icon }}"></i>
                  <span>{{ menuItem.title | translate }}</span>
                  <div class="according-menu" *ngIf="menuItem.children?.length">
                    <i class="fa" [ngClass]="menuItem.active ? 'fa-angle-down' : 'fa-angle-right'"></i>
                  </div>
                </a>
              </ng-container>

              <!-- LINK (Top level) -->
              <ng-container *ngIf="menuItem.type === 'link'">
                <a
                  [routerLink]="parseRouterLink(menuItem.path).link"
                  [queryParams]="parseRouterLink(menuItem.path).queryParams"
                  routerLinkActive="active"
                  class="sidebar-link sidebar-title"
                  [class.link-nav]="!menuItem.children"
                  [ngClass]="{ active: menuItem.active }"
                >
                  <i class="side-icon {{ menuItem.icon }}"></i>
                  <span>{{ menuItem.title | translate }}</span>
                  <div class="according-menu" *ngIf="menuItem.children?.length">
                    <i class="fa" [ngClass]="menuItem.active ? 'fa-angle-down' : 'fa-angle-right'"></i>
                  </div>
                </a>
              </ng-container>

              <!-- External links (Top level) -->
              <ng-container *ngIf="menuItem.type === 'extLink'">
                <a [routerLink]="parseRouterLink(menuItem.path).link"
                  [queryParams]="parseRouterLink(menuItem.path).queryParams" class="sidebar-link sidebar-title" [class.link-nav]="!menuItem.children">
                  <i class="side-icon {{ menuItem.icon }}"></i>
                  <span>{{ menuItem.title | translate }}</span>
                </a>
              </ng-container>

              <ng-container *ngIf="menuItem.type === 'extTabLink'">
                <a [routerLink]="parseRouterLink(menuItem.path).link"
                  [queryParams]="parseRouterLink(menuItem.path).queryParams" target="_blank" class="sidebar-link sidebar-title" [class.link-nav]="!menuItem.children">
                  <i class="side-icon {{ menuItem.icon }}"></i>
                  <span>{{ menuItem.title | translate }}</span>
                </a>
              </ng-container>

              <!-- ===== 2nd Level ===== -->
              <ng-container *ngIf="menuItem.children?.length">
                <ul
                  class="sidebar-submenu"
                  [ngClass]="{ 'menu-open': menuItem.active, 'menu-close': !menuItem.active }"
                  [style.display]="menuItem.active ? 'block' : 'none'"
                >
                  <ng-container *ngFor="let child of menuItem.children">
                    <ng-container *ngIf="child.hasPermission">
                      <li id="tour-{{ child.id }}" [ngClass]="{ active: child.active }">
                        <!-- SUB (2nd level) -->
                        <ng-container *ngIf="child.type === 'sub'">
                          <a class="submenu-title" href="javascript:void(0)" (click)="toggleMenuAndTour(child)">
                            <span>{{ child.title | translate }}</span>
                            <div class="according-menu" *ngIf="child.children?.length">
                              <i class="fa" [ngClass]="child.active ? 'fa-angle-down' : 'fa-angle-right'"></i>
                            </div>
                          </a>
                        </ng-container>

                        <!-- LINK (2nd level) -->
                        <ng-container *ngIf="child.type === 'link'">
                          <a
                            class="submenu-title"
                            [routerLink]="parseRouterLink(child.path).link"
                            [queryParams]="parseRouterLink(child.path).queryParams"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                          >
                            {{ child.title | translate }}
                          </a>
                        </ng-container>

                        <!-- External (2nd level) -->
                        <ng-container *ngIf="child.type === 'extLink'">
                          <a class="submenu-title" [href]="child.path">
                            {{ child.title | translate }}
                          </a>
                        </ng-container>

                        <ng-container *ngIf="child.type === 'extTabLink'">
                          <a class="submenu-title" [href]="child.path" target="_blank">
                            <span>{{ child.title | translate }}</span>
                          </a>
                        </ng-container>

                        <!-- ===== 3rd Level ===== -->
                        <ng-container *ngIf="child.children?.length">
                          <ul
                            class="nav-sub-childmenu submenu-content"
                            [ngClass]="{ 'menu-open': child.active, 'menu-close': !child.active }"
                            [style.display]="child.active ? 'block' : 'none'"
                          >
                            <ng-container *ngFor="let grand of child.children">
                              <ng-container *ngIf="grand.hasPermission">
                                <li id="tour-{{ grand.id }}" [ngClass]="{ active: grand.active }">
                                  <!-- LINK (3rd level) -->
                                  <ng-container *ngIf="grand.type === 'link'">
                                    <a
                                      [routerLink]="parseRouterLink(grand.path).link"
                                      [queryParams]="parseRouterLink(grand.path).queryParams"
                                      routerLinkActive="active"
                                      [routerLinkActiveOptions]="{ exact: true }"
                                    >
                                      {{ grand.title | translate }}
                                    </a>
                                  </ng-container>

                                  <!-- External (3rd level) -->
                                  <ng-container *ngIf="grand.type === 'extLink'">
                                    <a [href]="grand.path">{{ grand.title | translate }}</a>
                                  </ng-container>

                                  <ng-container *ngIf="grand.type === 'extTabLink'">
                                    <a [href]="grand.path" target="_blank">{{ grand.title | translate }}</a>
                                  </ng-container>
                                </li>
                              </ng-container>
                            </ng-container>
                          </ul>
                        </ng-container>
                        <!-- ===== End 3rd Level ===== -->
                      </li>
                    </ng-container>
                  </ng-container>
                </ul>
              </ng-container>
              <!-- ===== End 2nd Level ===== -->
            </li>
          </ng-container>
        </ng-container>
      </ng-container>
      <!-- ===== End Grouped Sections ===== -->

    </ul>
  </div>

  <div class="right-arrow" id="right-arrow" [class.d-none]="rightArrowNone" (click)="scrollToRight()">
    <app-feather-icons [icon]="'arrow-right'"></app-feather-icons>
  </div>
</nav>
